import ButtonLinkElement from "@/app/(site)/_components/GCMolecules/ButtonLinkElement"
import { useHasMounted } from "@/app/(site)/_utils/_hooks/useHasMounted"

type LoadMoreButtonProps = {
    title: string
    onClick?: (
        e: React.MouseEvent<HTMLDivElement> | React.MouseEvent<HTMLAnchorElement>
    ) => void
    href?: string
    isLoading?: boolean
}

export const LoadMoreButton = ({
    title,
    onClick,
    href,
    isLoading
}: LoadMoreButtonProps) => {
    const hasMounted = useHasMounted()

    const buttonProps = {
        text: isLoading && hasMounted && onClick ? "Loading..." : title,
        theme: "primary-black" as const,
        size: { desktop: "large" as const, mobile: "small" as const },
        link: { _type: "generalLink", internal: href || "" },
        disabled: false,
        className: "min-w-[152px] w-full lg:w-[334px] justify-center"
    }

    return (
        <div
            onClick={
                hasMounted && onClick
                    ? e => {
                          e.preventDefault()
                          e.stopPropagation()
                          onClick(e)
                      }
                    : undefined
            }
        >
            <ButtonLinkElement {...buttonProps} />
        </div>
    )
}
